import { Observable } from 'rxjs';
import { SyncResult } from '../models/permit-sync.model';
import {
    AddInternalNotePayload,
    AddSubtasksPayload,
    AdminCreatePermitPayload,
    AdminPermitDetail,
    AdminPermitListItem,
    AdminSendMessagePayload,
    AdminUpdatePermitPayload,
    AssignSubtaskPayload,
    AttachFilePayload,
    CreateLinkPayload,
    EditInternalNotePayload,
    InternalFilePayload,
    PermitCreatedResponse,
    UpdateCategoryAndTypePayload,
    UpdateDepartmentPayload,
    UpdateFeePayload,
    UpdateLinkPayload,
    UpdateStatusPayload,
    UpdateSubtaskPayload,
    UpdateTagsPayload,
} from '../models/permit.model';
import { AdminPermitFilters, PermitPaginatedResult } from '../models/permit-filters.model';

export abstract class PermitV2Service {
    abstract getPermits(filters?: AdminPermitFilters): Observable<PermitPaginatedResult<AdminPermitListItem>>;

    abstract getPermitById(id: string): Observable<AdminPermitDetail>;

    abstract createPermit(payload: AdminCreatePermitPayload): Observable<PermitCreatedResponse>;

    abstract updatePermit(id: string, payload: AdminUpdatePermitPayload): Observable<AdminPermitDetail>;

    abstract deletePermit(id: string): Observable<void>;

    abstract updateStatus(id: string, payload: UpdateStatusPayload): Observable<any>;

    abstract updateDepartment(id: string, payload: UpdateDepartmentPayload): Observable<any>;

    abstract updateTags(id: string, payload: UpdateTagsPayload): Observable<any>;

    abstract updateCategoryAndType(id: string, payload: UpdateCategoryAndTypePayload): Observable<AdminPermitDetail>;

    abstract updateFee(id: string, payload: UpdateFeePayload): Observable<any>;

    // Messages
    abstract sendMessage(id: string, payload: AdminSendMessagePayload): Observable<any>;

    abstract markMessagesAsRead(id: string): Observable<any>;

    // Files
    abstract uploadTempFile(file: File): Observable<string[]>;

    abstract attachFiles(id: string, payload: AttachFilePayload): Observable<any>;

    abstract deleteFile(id: string, index: number): Observable<void>;

    abstract attachInternalFiles(id: string, payload: InternalFilePayload): Observable<any>;

    abstract deleteInternalFile(id: string, index: number): Observable<void>;

    // Internal notes
    abstract addInternalNote(id: string, payload: AddInternalNotePayload): Observable<any>;

    abstract editInternalNote(id: string, noteId: string, payload: EditInternalNotePayload): Observable<any>;

    // Subtasks
    abstract addSubtasks(id: string, payload: AddSubtasksPayload): Observable<any>;

    abstract updateSubtask(id: string, subtaskId: string, payload: UpdateSubtaskPayload): Observable<any>;

    abstract assignSubtask(id: string, subtaskId: string, payload: AssignSubtaskPayload): Observable<any>;

    abstract deleteSubtask(id: string, subtaskId: string): Observable<void>;

    // Links
    abstract createLink(id: string, payload: CreateLinkPayload): Observable<any>;

    abstract updateLink(id: string, payload: UpdateLinkPayload): Observable<any>;

    abstract deleteLink(id: string, linkedPermitId: string): Observable<void>;

    // Connector sync (PSD). Two separate calls so the caller can sequence them
    // and report each outcome on its own.
    abstract syncConnectorCategories(): Observable<SyncResult>;

    abstract syncConnectorPermits(): Observable<SyncResult>;
}
